import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'

export function useAccessUser() {
  const page = usePage()

  const user = computed(() => page.props.auth.user)
  const currentLocation = computed(() => page.props.auth.current_location?.data)

  return { user, currentLocation }
}
